<template>
  <div class="nlp__coin-select-box">
    <vSelect
      ref="nlpCoinSelect"
      v-model="coin"
      :clearable="false"
      :options="currencyList"
      :searchable="false"
      @close="closeSelect"
      @input="handleCoinSelect"
      @open="handleOpenSelect"
    >
      <template 
        v-if="isNlpMobile" 
        #list-header
      >
        <div class="nlp__coin-select-box-header">
          <div class="nlp__coin-select-box-header-text">
            Choose Blockchain
          </div>
          <div 
            class="nlp__coin-select-box-header-close"
            @click="closeSelect"
          >
            <gl-icon
              :height="12"
              name="close"
              :width="12"
            />
          </div>
        </div>
      </template>
      <template #selected-option="{ key }">
        <gl-blockchain-icon :blockchain-icon="key" />
        <div>{{ key }}</div>
      </template>
      <template #option="{ key }">
        <gl-blockchain-icon :blockchain-icon="key" />
        <div>{{ key }}</div>
      </template>
      <template #open-indicator>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.4752 14.475L7.8502 10.85C7.8002 10.8 7.7627 10.7458 7.7377 10.6875C7.7127 10.6292 7.7002 10.5667 7.7002 10.5C7.7002 10.3667 7.74603 10.25 7.8377 10.15C7.92936 10.05 8.0502 10 8.2002 10H15.8002C15.9502 10 16.071 10.05 16.1627 10.15C16.2544 10.25 16.3002 10.3667 16.3002 10.5C16.3002 10.5333 16.2502 10.65 16.1502 10.85L12.5252 14.475C12.4419 14.5583 12.3585 14.6167 12.2752 14.65C12.1919 14.6833 12.1002 14.7 12.0002 14.7C11.9002 14.7 11.8085 14.6833 11.7252 14.65C11.6419 14.6167 11.5585 14.5583 11.4752 14.475Z" fill="#5A627D"/>
        </svg>
      </template>
    </vSelect>
    <div
      v-if="isSelectOpen && isNlpMobile" 
      class="gl-input__backfog"
    />
  </div>
</template>

<script>
// Vue
import { mapMutations, mapState } from 'vuex'

// Components
import vSelect from 'vue-select'
import GlBlockchainIcon from '@/components/gl-blockchain-icon.vue'
import GlIcon from '@/components/gl-icon.vue'

//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'NlpCoinSelect',
  components: {
    vSelect,
    GlBlockchainIcon,
    GlIcon,
  },
  mixins: [deviceWidthMixin],
  props: {
    parentBlock: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSelectOpen: false,
      coin: {},
    }
  },
  computed: {
    ...mapState('analytics', ['coinType', 'currencyList']),
  },
  watch: {
    coinType: {
      handler(coin) {
        this.changeCoin(coin)
      },
      immediate: true,
    },
    currencyList: {
      handler(coin) {
        this.changeCoin(coin)
      },
    }
  },
  methods: {
    ...mapMutations({
      SET_COIN_TYPE: 'analytics/SET_COIN_TYPE',
      SET_COIN_DATA: 'analytics/SET_COIN_DATA',
      SET_Z_INDEX_BLOCK: 'nlp/SET_Z_INDEX_BLOCK',
    }),
    handleOpenSelect() {
      this.isSelectOpen = true
      this.SET_Z_INDEX_BLOCK(this.parentBlock)
    },
    handleCoinSelect(data) {
      this.SET_COIN_TYPE(data.key)
      this.SET_COIN_DATA(data)
      this.$emit('change', data)
      this.SET_Z_INDEX_BLOCK('')
    },
    changeCoin(coin) {
      this.coin = this.currencyList.find(item => item.key === coin) || this.currencyList[0]
    },
    closeSelect() {
      this.isSelectOpen = false
      this.$refs.nlpCoinSelect?.$refs.search?.blur()
      this.SET_Z_INDEX_BLOCK('')
    },
  },
}
</script>

<style>
.nlp__coin-select-box {
  width: 100px;
  height: 32px;
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
  color: #5A627D;
  text-transform: uppercase;
}
.nlp__coin-select-box .v-select,
.nlp__coin-select-box .vs__dropdown-toggle,
.nlp__coin-select-box .vs__selected-options,
.nlp__coin-select-box .vs__selected,
.nlp__coin-select-box .vs__actions,
.nlp__coin-select-box .vs__search {
  align-items: center;
  height: 32px !important;
  min-height: 32px !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.nlp__coin-select-box .vs__dropdown-option,
.nlp__coin-select-box .vs__selected {
  gap: 6px;
}
.nlp__coin-select-box .vs__selected {
  align-items: center;
  height: 24px !important;
  min-height: 24px !important;
  font-size: 18px;
  color: #5A627D;
}
.nlp__coin-select-box .vs__actions svg {
  transition: transform 0.3s ease;
}

.nlp__coin-select-box .vs--open {
  border: none;
}
.nlp__coin-select-box .vs--open .vs__selected {
  opacity: 1;
  position: relative;
}
.nlp__coin-select-box .vs--open .vs__actions svg {
  transform: rotate(180deg);
}
.nlp__coin-select-box .pp-blockchain-icon {
  width: 32px;
  height: 32px;
}
.nlp__coin-select-box .pp-blockchain-icon svg,
.nlp__coin-select-box .pp-blockchain-icon img {
  width: 32px;
  height: 32px;
}
.nlp__coin-select-box .pp-blockchain-icon + div {
  height: 24px;
  line-height: 24px;
}

.nlp__coin-select-box .vs__dropdown-menu {
  width: 120px !important;
  left: -8px !important;
}
.nlp__coin-select-box .vs__dropdown-option {
  min-height: 52px;
  margin: 0;
  padding: 0 0 0 16px !important;
}
.gl-input__backfog {
  background-color: var(--Background-tint);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.nlp__coin-select-box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--Basic-100);
}
.nlp__coin-select-box-header-text {
  font-weight: 700;
  font-size: 16px;
  text-transform: capitalize;
}
.nlp__coin-select-box-header-icon {
  padding: 4px;
}

@media (max-width: 767px) {
  .nlp__coin-select-box {
    width: 96px;
    font-size: 16px;
  }
  .nlp__coin-select-box .vs__selected {
    font-size: 16px;
  }
  .nlp__coin-select-box .vs__dropdown-menu {
    width: 100% !important;
    padding-bottom: 24px !important;
    border-radius: var(--Corner-radius-XL) var(--Corner-radius-XL) 0 0 !important;
    position: fixed !important;
    right: auto !important;
    left: 0 !important;
    top: auto !important;
    bottom: 0 !important;
    z-index: 100;
  }
}
</style>
